















import { Component, Vue } from 'vue-property-decorator'
import VerifyOTP from '../../../Login/components/VerifyOTP/index.vue'
import AuthController from '@/app/ui/controllers/AuthController';
import { ExchangeOTPRequest } from '@/data/payload/api/AuthRequest';

@Component({
  components: { VerifyOTP }
})
class MfaVerifyOtp extends Vue {
  created(): void {
    if (!AuthController.enrollmentSessionActive) {
      this.$router.replace({
        name: 'AccountSettingPage'
      })

      return
    }
  }

  get maskedEmail(): string {
    return AuthController.enrollmentMaskedEmail
  }

  get isLoading(): boolean {
    return AuthController.isLoading
  }

  get otpErrorMessage(): string {
    return AuthController.mfaVerifyErrorMessage
  }

  get cooldownIn(): number {
    return AuthController.enrollmentCooldownIn
  }

  onVerify(otp: string): void {
    const request = new ExchangeOTPRequest({
      otpId: AuthController.enrollmentOtpId,
      otp: otp
    });
    AuthController.verifyMfaEnrollment(request)
  }

  async onResend(): Promise<void> {
    await AuthController.resendMfaEnrollmentOtp();

    const verifyOtpComponent = this?.$refs?.verifyOtp as any
    verifyOtpComponent?.restartCountdown(
      AuthController.enrollmentCooldownIn
    )
  }

  onBack(): void {
    AuthController.clearEnrollmentVerifyState()

    this.$router.push({
      name: 'AccountSettingPage'
    })
  }
}

export default MfaVerifyOtp
